/* Bills N Bally — Offshore Report page
   NOAA/NWS marine forecast (api.weather.gov, public domain) + official Facebook page embeds. */
(function () {
  var root = document.getElementById('bnb-offshore');
  if (!root) return;

  var NAVY = '#10265f', RED = '#c8102e';
  var PORTS = [
    ['Palm Beach, FL', 26.75, -79.85], ['Miami, FL', 25.7, -79.95], ['Key West, FL', 24.35, -81.8],
    ['Cape Canaveral, FL', 28.4, -80.3], ['Outer Banks, NC', 35.6, -75.2], ['Ocean City, MD', 38.2, -74.8],
    ['Montauk, NY', 40.9, -71.8], ['Destin, FL', 30.2, -86.6], ['Venice, LA', 28.8, -89.3],
    ['Port Aransas, TX', 27.65, -96.9], ['San Diego, CA', 32.6, -117.5], ['Kona, HI', 19.6, -156.1]
  ];
  var CANYONS = [
    ['Hudson Canyon', 39.552, -72.407], ['Toms Canyon', 39.166, -72.751], ['Hendrickson Canyon', 39.096, -72.492],
    ['Carteret Canyon', 38.910, -72.907], ['Lindenkohl Canyon', 38.821, -73.030], ['Wilmington Canyon', 38.499, -73.491],
    ['Baltimore Canyon', 38.242, -73.844], ["Poor Man's Canyon", 37.873, -74.108], ['Washington Canyon', 37.479, -74.509]
  ];
  var NEWS_URL = 'https://script.google.com/macros/s/AKfycbwnMOAr3-3a4cYW7QgIxLarJaMzmiloajXlDK7x4Sx9mwZu6_TFwaXPfNHRMEU_vwhE/exec';
  var FB_PAGES = [
    ['Marlin Magazine', 'https://www.facebook.com/marlinmag'],
    ['Sport Fishing', 'https://www.facebook.com/SportFishing'],
    ['The Billfish Foundation', 'https://www.facebook.com/BillfishFoundation']
  ];
  var LINKS = [
    ['Marlin Magazine — News & Tournaments', 'https://www.marlinmag.com/'],
    ['Sport Fishing — Offshore Tips', 'https://www.sportfishingmag.com/'],
    ['Salt Water Sportsman — How-To', 'https://www.saltwatersportsman.com/'],
    ['On The Water — Weekly Fishing Reports', 'https://onthewater.com/fishing-reports'],
    ['IGFA — Records & News', 'https://igfa.org/'],
    ['NOAA — Marine Forecasts', 'https://www.weather.gov/marine/'],
    ['NOAA CoastWatch — Sea Surface Temps', 'https://coastwatch.noaa.gov/']
  ];

  var css = '' +
    '#bnb-offshore{--navy:' + NAVY + ';--red:' + RED + ';color:#1b1f2a;font-family:inherit;max-width:1200px;margin:0 auto;padding:24px 16px 48px;box-sizing:border-box}' +
    '#bnb-offshore *{box-sizing:border-box}' +
    '#bnb-offshore .bo-hero{text-align:center;margin-bottom:28px}' +
    '#bnb-offshore .bo-hero h1{color:var(--navy);font-size:clamp(28px,5vw,44px);letter-spacing:.06em;text-transform:uppercase;margin:0 0 6px}' +
    '#bnb-offshore .bo-hero p{margin:0;color:#4a5161}' +
    '#bnb-offshore .bo-tags{display:flex;gap:8px;justify-content:center;flex-wrap:wrap;margin-top:12px}' +
    '#bnb-offshore .bo-tags span{background:var(--navy);color:#fff;font-size:12px;letter-spacing:.1em;text-transform:uppercase;padding:5px 12px;border-radius:999px}' +
    '#bnb-offshore h2{color:var(--navy);text-transform:uppercase;letter-spacing:.08em;font-size:20px;margin:0 0 12px;border-left:4px solid var(--red);padding-left:10px}' +
    '#bnb-offshore section{margin-bottom:40px}' +
    '#bnb-offshore .bo-wx{display:grid;grid-template-columns:minmax(0,1.4fr) minmax(0,1fr);gap:16px}' +
    '@media(max-width:860px){#bnb-offshore .bo-wx{grid-template-columns:1fr}}' +
    '#bnb-offshore #bo-map{height:460px;border-radius:10px;border:1px solid #d7dbe4;z-index:0}' +
    '@media(max-width:600px){#bnb-offshore #bo-map{height:340px}}' +
    '#bnb-offshore .bo-panel{border:1px solid #d7dbe4;border-radius:10px;padding:16px;background:#f7f8fb;max-height:460px;overflow:auto}' +
    '#bnb-offshore .bo-zone{font-weight:700;color:var(--navy);margin:0 0 4px}' +
    '#bnb-offshore .bo-meta{font-size:12px;color:#667;margin:0 0 12px}' +
    '#bnb-offshore .bo-alert{background:#fff4e5;border-left:4px solid #e67e00;padding:8px 10px;margin:0 0 10px;font-size:14px;border-radius:4px}' +
    '#bnb-offshore .bo-period{margin:0 0 10px;font-size:14px;line-height:1.45}' +
    '#bnb-offshore .bo-period b{color:var(--navy)}' +
    '#bnb-offshore .bo-ports{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 12px}' +
    '#bnb-offshore .bo-ports button{border:1px solid var(--navy);background:#fff;color:var(--navy);border-radius:999px;padding:5px 11px;font-size:13px;cursor:pointer}' +
    '#bnb-offshore .bo-ports button.on,#bnb-offshore .bo-ports button:hover{background:var(--navy);color:#fff}' +
    '#bnb-offshore .bo-row-label{font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--red);margin:0 0 6px}' +
    '#bnb-offshore .bo-ports button.bo-cy{border-color:var(--red);color:var(--red)}' +
    '#bnb-offshore .bo-ports button.bo-cy.on,#bnb-offshore .bo-ports button.bo-cy:hover{background:var(--red);color:#fff}' +
    '#bnb-offshore .bo-hint{font-size:13px;color:#4a5161;margin:0 0 8px}' +
    '#bnb-offshore a.bo-btn{display:inline-block;margin-top:6px;color:#fff;background:var(--red);padding:7px 12px;border-radius:6px;text-decoration:none;font-size:13px}' +
    '#bnb-offshore .bo-fb{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px}' +
    '@media(max-width:1000px){#bnb-offshore .bo-fb{grid-template-columns:repeat(2,minmax(0,1fr))}}' +
    '@media(max-width:640px){#bnb-offshore .bo-fb{grid-template-columns:1fr}}' +
    '#bnb-offshore .bo-fb div{border:1px solid #d7dbe4;border-radius:10px;overflow:hidden;background:#fff}' +
    '#bnb-offshore .bo-fb iframe{display:block;width:100%;height:150px;border:0}' +
    '#bnb-offshore .bo-links{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:10px;list-style:none;padding:0;margin:0}' +
    '#bnb-offshore .bo-links a{display:block;border:1px solid #d7dbe4;border-radius:8px;padding:12px 14px;color:var(--navy);text-decoration:none;font-weight:600;background:#fff}' +
    '#bnb-offshore .bo-links a:hover{border-color:var(--red)}' +
    '#bnb-offshore .bo-note{font-size:12px;color:#778;margin-top:8px}' +
    '#bnb-offshore .bo-news{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px}' +
    '@media(max-width:1000px){#bnb-offshore .bo-news{grid-template-columns:repeat(2,minmax(0,1fr))}}' +
    '@media(max-width:640px){#bnb-offshore .bo-news{grid-template-columns:1fr}}' +
    '#bnb-offshore .bo-card{display:flex;flex-direction:column;border:1px solid #d7dbe4;border-top:3px solid var(--navy);border-radius:10px;padding:14px 16px;background:#fff;text-decoration:none;color:inherit}' +
    '#bnb-offshore .bo-card:hover{border-top-color:var(--red);box-shadow:0 4px 14px rgba(16,38,95,.1)}' +
    '#bnb-offshore .bo-src{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--red);font-weight:700;margin:0 0 6px}' +
    '#bnb-offshore .bo-card h3{font-size:16px;line-height:1.3;color:var(--navy);margin:0 0 8px}' +
    '#bnb-offshore .bo-card p.bo-snip{font-size:14px;line-height:1.45;color:#4a5161;margin:0 0 10px;flex:1}' +
    '#bnb-offshore .bo-more{font-size:13px;font-weight:700;color:var(--red)}' +
    '#bnb-offshore .bo-showmore{display:block;margin:16px auto 0;border:1px solid var(--navy);background:#fff;color:var(--navy);border-radius:999px;padding:8px 18px;font-size:14px;cursor:pointer}' +
    '#bnb-offshore .bo-showmore:hover{background:var(--navy);color:#fff}';

  var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  root.innerHTML =
    '<div class="bo-hero"><h1>Offshore Report</h1><p>Live NOAA marine forecasts and the latest from the offshore fleet.</p>' +
    '<div class="bo-tags"><span>Marlin</span><span>Sailfish</span><span>Tuna</span><span>Offshore</span></div></div>' +
    '<section><h2>Marine Forecast</h2>' +
    '<p class="bo-hint">Tap anywhere on the water or pick a port to load the official NOAA marine forecast.</p>' +
    '<p class="bo-row-label">Ports</p><div class="bo-ports">' + PORTS.map(function (p, i) { return '<button type="button" data-i="' + i + '">' + esc(p[0]) + '</button>'; }).join('') + '</div>' +
    '<p class="bo-row-label">NJ &amp; Mid-Atlantic Canyons</p><div class="bo-ports">' + CANYONS.map(function (p, i) { return '<button type="button" class="bo-cy" data-c="' + i + '">' + esc(p[0]) + '</button>'; }).join('') + '</div>' +
    '<div class="bo-wx"><div id="bo-map" role="application" aria-label="Marine forecast map"></div><div class="bo-panel" id="bo-panel" aria-live="polite">Loading forecast…</div></div>' +
    '<p class="bo-note">Forecast data: NOAA / National Weather Service. Always check official sources before heading offshore.</p></section>' +
    '<section><h2>Latest Offshore News</h2><p class="bo-hint">Marlin, sailfish and tuna stories, reports and tips from around the web. Updated hourly.</p>' +
    '<div class="bo-news" id="bo-news"><p class="bo-hint">Loading the latest stories\u2026</p></div></section>' +
    '<section><h2>Follow the Fleet</h2><p class="bo-hint">Daily reports, catches and tournament news from the offshore community.</p><div class="bo-fb">' +
    FB_PAGES.map(function (p) {
      var src = 'https://www.facebook.com/plugins/page.php?href=' + encodeURIComponent(p[1]) +
        '&tabs=&width=500&height=150&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false';
      return '<div><iframe title="' + esc(p[0]) + ' on Facebook" src="' + src + '" loading="lazy" scrolling="no" allowfullscreen allow="encrypted-media; picture-in-picture; web-share"></iframe></div>';
    }).join('') + '</div></section>' +
    '<section><h2>Offshore Reading</h2><ul class="bo-links">' +
    LINKS.map(function (l) { return '<li><a href="' + l[1] + '" target="_blank" rel="noopener">' + esc(l[0]) + ' &rarr;</a></li>'; }).join('') +
    '</ul></section>';

  var panel = document.getElementById('bo-panel');
  (function loadNews() {
    var box = document.getElementById('bo-news');
    function card(it) {
      var d = it.date ? new Date(it.date).toLocaleDateString([], { month: 'short', day: 'numeric' }) : '';
      return '<a class="bo-card" href="' + esc(it.link) + '" target="_blank" rel="noopener">' +
        '<p class="bo-src">' + esc(it.source) + (d ? ' \u00b7 ' + esc(d) : '') + '</p>' +
        '<h3>' + esc(it.title) + '</h3>' + (it.snippet ? '<p class="bo-snip">' + esc(it.snippet) + '</p>' : '') +
        '<span class="bo-more">Read on ' + esc(it.source) + ' &rarr;</span></a>';
    }
    fetch(NEWS_URL).then(function (r) { return r.json(); }).then(function (j) {
      var items = (j && j.items) || [];
      if (!items.length) { box.innerHTML = '<p class="bo-hint">No new offshore stories today. Check back soon.</p>'; return; }
      box.innerHTML = items.slice(0, 9).map(card).join('');
      if (items.length > 9) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'bo-showmore'; btn.textContent = 'Show more stories';
        btn.addEventListener('click', function () { box.innerHTML = items.map(card).join(''); btn.remove(); });
        box.parentNode.appendChild(btn);
      }
    }).catch(function () {
      box.innerHTML = '<p class="bo-hint">Stories are taking a break. See the Offshore Reading links below.</p>';
    });
  })();
  var map, marker;

  function api(url) {
    return fetch(url, { headers: { Accept: 'application/geo+json' } }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    });
  }

  function noaaLink(zoneId) {
    return 'https://forecast.weather.gov/shmrn.php?mz=' + String(zoneId).toLowerCase();
  }
  var OFF_LOCS = { AN: ['NT1', 'NT2'], AM: ['NT5', 'NT3', 'NT2'], GM: ['NT4', 'NT3'], PZ: ['PZ6', 'PZ5', 'PZ7', 'PZ8'], PH: ['HFO'], PK: ['ALU', 'AER', 'AFG', 'AJK'] };
  function offshoreText(zoneId) {
    var locs = OFF_LOCS[zoneId.slice(0, 2)] || ['NT1', 'NT2', 'NT3', 'NT4', 'NT5'];
    function tryLoc(i) {
      if (i >= locs.length) return Promise.reject(new Error('not found'));
      return api('https://api.weather.gov/products/types/OFF/locations/' + locs[i]).then(function (r) {
        var g = (r.j['@graph'] || [])[0];
        if (!g) return tryLoc(i + 1);
        return api('https://api.weather.gov/products/' + g.id).then(function (pr) {
          var t = pr.j.productText || '';
          var a = t.indexOf(zoneId + '-');
          if (a < 0) return tryLoc(i + 1);
          var b = t.indexOf('$$', a);
          return { text: t.slice(a, b > a ? b : a + 3000), issued: pr.j.issuanceTime };
        });
      });
    }
    return tryLoc(0);
  }
  function fmtOffshore(text) {
    var body = text.split(/\n\s*\n/).slice(1).join('\n').replace(/\n(?!\.)/g, ' ');
    return body.split('\n').map(function (l) {
      var m = l.match(/^\.([^.]+)\.\.\.(.*)$/);
      if (!m) return l.trim() ? '<p class="bo-period">' + esc(l.trim()) + '</p>' : '';
      var name = m[1].toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      return '<p class="bo-period"><b>' + esc(name) + ':</b> ' + esc(m[2].trim()) + '</p>';
    }).slice(0, 8).join('');
  }

  function load(lat, lon, label) {
    if (marker) marker.setLatLng([lat, lon]); else if (map) marker = L.marker([lat, lon]).addTo(map);
    panel.innerHTML = 'Loading forecast…';
    var pt = lat.toFixed(4) + ',' + lon.toFixed(4);
    Promise.all([
      api('https://api.weather.gov/zones?point=' + pt).catch(function () { return { ok: false, j: {} }; }),
      api('https://api.weather.gov/alerts/active?point=' + pt).catch(function () { return { ok: false, j: {} }; })
    ]).then(function (res) {
      var zones = (res[0].j.features || []).filter(function (f) { return /coastal|offshore|marine/.test(f.properties.type); });
      var alerts = (res[1].j.features || []).map(function (f) { return f.properties; });
      var alertHtml = alerts.slice(0, 4).map(function (a) {
        return '<div class="bo-alert"><b>' + esc(a.event) + '</b>' + (a.headline ? '<br>' + esc(a.headline) : '') + '</div>';
      }).join('');
      if (!zones.length) {
        panel.innerHTML = (label ? '<p class="bo-zone">' + esc(label) + '</p>' : '') + alertHtml +
          '<p>No NOAA marine zone at this spot. Tap on open water along the U.S. coast, Gulf, Great Lakes or Hawaii.</p>';
        return;
      }
      var z = zones[0].properties;
      var head = '<p class="bo-zone">' + esc(label || z.name) + '</p><p class="bo-meta">' + esc(z.id) + (label ? ' · ' + esc(z.name) : '') + '</p>' + alertHtml;
      if (z.type === 'offshore') {
        offshoreText(z.id).then(function (o) {
          var upd = o.issued ? new Date(o.issued).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '';
          panel.innerHTML = head + (upd ? '<p class="bo-meta">Offshore forecast · issued ' + esc(upd) + '</p>' : '') + fmtOffshore(o.text) +
            '<a class="bo-btn" href="' + noaaLink(z.id) + '" target="_blank" rel="noopener">Full NOAA forecast</a>';
        }).catch(function () {
          panel.innerHTML = head + '<a class="bo-btn" href="' + noaaLink(z.id) + '" target="_blank" rel="noopener">Open NOAA offshore forecast</a>';
        });
        return;
      }
      api('https://api.weather.gov/zones/' + z.type + '/' + z.id + '/forecast').then(function (fr) {
        var periods = (fr.j.properties && fr.j.properties.periods) || [];
        if (!periods.length) {
          panel.innerHTML = head + '<p>Forecast is temporarily unavailable.</p><a class="bo-btn" href="' + noaaLink(z.id) + '" target="_blank" rel="noopener">Open on NOAA</a>';
          return;
        }
        var upd = fr.j.properties.updated ? new Date(fr.j.properties.updated).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '';
        panel.innerHTML = head + (upd ? '<p class="bo-meta">Updated ' + esc(upd) + '</p>' : '') +
          periods.slice(0, 6).map(function (p) { return '<p class="bo-period"><b>' + esc(p.name) + ':</b> ' + esc(p.detailedForecast) + '</p>'; }).join('') +
          '<a class="bo-btn" href="' + noaaLink(z.id) + '" target="_blank" rel="noopener">Full NOAA forecast</a>';
      }).catch(function () {
        panel.innerHTML = head + '<a class="bo-btn" href="' + noaaLink(z.id) + '" target="_blank" rel="noopener">Open NOAA forecast</a>';
      });
    });
  }

  var btns = root.querySelectorAll('.bo-ports button');
  function choose(p, btn) {
    for (var k = 0; k < btns.length; k++) btns[k].classList.toggle('on', btns[k] === btn);
    if (map) map.setView([p[1], p[2]], 7);
    load(p[1], p[2], p[0]);
  }
  function pick(i) { choose(PORTS[i], root.querySelector('[data-i="' + i + '"]')); }
  function pickCanyon(i) { choose(CANYONS[i], root.querySelector('[data-c="' + i + '"]')); }
  for (var b = 0; b < btns.length; b++) btns[b].addEventListener('click', function () {
    if (this.hasAttribute('data-c')) pickCanyon(+this.getAttribute('data-c')); else pick(+this.getAttribute('data-i'));
  });

  function addCss(href) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
  function initMap() {
    map = L.map('bo-map', { scrollWheelZoom: false, worldCopyJump: true }).setView([PORTS[0][1], PORTS[0][2]], 6);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 12, attribution: '&copy; OpenStreetMap contributors | Forecasts: NOAA/NWS'
    }).addTo(map);
    CANYONS.forEach(function (c, i) {
      L.circleMarker([c[1], c[2]], { radius: 6, color: RED, weight: 2, fillColor: '#fff', fillOpacity: 1 })
        .bindTooltip(c[0], { direction: 'right' })
        .on('click', function (e) { L.DomEvent.stopPropagation(e); pickCanyon(i); })
        .addTo(map);
    });
    map.on('click', function (e) {
      for (var k = 0; k < btns.length; k++) btns[k].classList.remove('on');
      load(e.latlng.lat, ((e.latlng.lng + 540) % 360) - 180);
    });
    pick(0);
  }
  if (window.L) initMap();
  else {
    addCss('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css');
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
    s.onload = initMap;
    s.onerror = function () { document.getElementById('bo-map').style.display = 'none'; pick(0); };
    document.head.appendChild(s);
  }
})();
